<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReceiptFromProductions"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="lotNo"
					 optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order" 
					 id="filter-" size="sm" :model.sync="filter.workOrderProcessDetailId" 
					 :selected="filter.workOrderProcessDetailObject != null ? filter.workOrderProcessDetailObject.lotNo : ''"
					 @change="checkFilter" @input="getWorkOrderProcessDetails" 
					 @focus="getWorkOrderProcessDetails" 
					 @onSelectMethod="onSelectedFilterWop" :isSelectMethodExists="true" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm" :model.sync="filter.documentStatusId" @change="checkFilter" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReceiptFromProductions"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Receipt From Production</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<!-- <b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/receiptfromproduction/ReceiptFromProduction.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown> -->
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<!-- <b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button> -->

					<!-- <b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay> -->

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-receiptfromproduction" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="receiptFromProductions" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="receiptFromProductions.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(workorderprocessdetail)="row">
						<!-- <a @click="() => ( $router.push({ name: 'receiptfromproductiondetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.workOrderProcessDetail.lotNo != null && row.item.workOrderProcessDetail.lotNo != "" ?
								(typeof row.item.lotNo == 'string') ?
									row.item.workOrderProcessDetail.lotNo.slice(0, 30) + (row.item.workOrderProcessDetail.lotNo.length > 30 ? "..." : "" ) : row.item.workOrderProcessDetail.lotNo : "" }}
						</a> -->
						<a v-if="row.item.documentStatusId == 'CLOSED'" @click="() => ( $router.push({ name: 'receiptfromproductiondetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.workOrderProcessDetail.lotNo != null && row.item.workOrderProcessDetail.lotNo != "" ?
								(typeof row.item.workOrderProcessDetail.lotNo == 'string') ?
									row.item.workOrderProcessDetail.lotNo.slice(0, 20) + (row.item.workOrderProcessDetail.lotNo.length > 20 ? "..." : "" ) : row.item.workOrderProcessDetail.lotNo : "" }}
						</a>
						<a v-if="row.item.documentStatusId == 'IN_PROGRESS'" @click="navigateToScanScreen(row.item.id)" class="a-link-detail">
							{{ row.item.workOrderProcessDetail.lotNo != null && row.item.workOrderProcessDetail.lotNo != "" ?
								(typeof row.item.workOrderProcessDetail.lotNo == 'string') ?
									row.item.workOrderProcessDetail.lotNo.slice(0, 20) + (row.item.workOrderProcessDetail.lotNo.length > 20 ? "..." : "" ) : row.item.workOrderProcessDetail.lotNo : "" }}
						</a>
					</template>
					<template v-slot:cell(line)="row">
						{{ row.item.workOrderProcessDetail != null ? 
							((row.item.workOrderProcessDetail.machine != null) ? 
								((row.item.workOrderProcessDetail.machine.lineCode != null) ? 
									row.item.workOrderProcessDetail.machine.lineCode.code : "") 
								: "") 
							: "" 
						}}
					</template>

					<template v-slot:cell(documentStatus)="row">
						<div class="two-item" v-if="!isMobileDevice">
							<span>{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }} </span>
							<span :class="getRectangleClass(row.item.documentStatusId)">&nbsp;</span>
						</div>
						<div v-else>
							<span :class="getRectangleClass(row.item.documentStatusId)">&nbsp;</span>
						</div>
					</template>

					<template v-slot:cell(front-action)="row">
						<!-- <div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div> -->
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(receiptFromProductionsPaging != null ? receiptFromProductionsPaging.dataCount : 0)"
									:per-page="(receiptFromProductionsPaging != null ? receiptFromProductionsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-receiptfromproduction.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-receiptfromproduction.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-receiptfromproduction.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }

	.two-item {
		display: flex;
		padding: 10px;
		justify-content: space-between;
		align-items: center;
	}
	.rectangle {
		display: inline-block;
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}
	// @media screen and (max-width: 400px) {
	// 	.two-item {
	// 		justify-content: space-around;
	// 	}
	// 	.rectangle {
	// 		width: 23px;
	// 		height: 23px;
	// 		margin-top: 10px;
	// 	}
	// }
	.rectangle-danger {
		background-color: #DC3545;
	}
	.rectangle-warning {
		background-color: #FFC107;
	}
	.rectangle-success {
		background-color: #28A745;
	}
</style>
<script>
import ReceiptFromProduction from '@/models/ReceiptFromProduction/ReceiptFromProduction';
import ReceiptFromProductionList from '@/models/ReceiptFromProduction/ReceiptFromProductionList';
import ReceiptFromProductionFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		ReceiptFromProduction, 
		ReceiptFromProductionList, 
		ReceiptFromProductionFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"workOrderProcessDetail": {}, "class" : "th-work-order-process-detail first-child", "label" : "Work Order", key: 'workOrderProcessDetail', sortable: true}, 
				{"line": {}, "class" : "th-line", "label" : "Line", key: 'line', sortable: false}, 
				{"documentStatus": {}, "class" : "th-document-status last-child", "label" : "Document Status", key: 'documentStatus', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			receiptFromProductions: [],
			receiptFromProductionsPaging: {},
			workOrderProcessDetails : [],
			documentStatuss : [],
			receiptFromProductionMaterials : [],
			receiptFromProductionCases : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			materials: [
				{ partId: 1, name: 'Material 1' },
				{ partId: 2, name: 'Material 2' },
				{ partId: 1, name: 'Material 3' },
			],
			groupedMaterials: [],
			isMobileDevice: false,
		}
	},	
	methods : {
		checkFilter() {
			console.log("checkFilter", this.filter);
		},
		onSelectedFilterWop(item) {
			this.filter.workOrderProcessDetailObject=item;
			if (item) {
				
				this.filter.workOrderProcessDetailId=item.id;
			}else{
				this.filter.workOrderProcessDetailId=null;
			}
		},
		testGrouping() {
			this.groupedMaterials = this.materials.reduce((acc, material) => {
			if (!acc[material.partId]) {
				acc[material.partId] = [];
			}
			acc[material.partId].push(material);
			return acc;
			}, {});

			console.log("test grouping", this.groupedMaterials);
			console.log("group 1", this.groupedMaterials[1]);
			console.log("group 2", this.groupedMaterials[2]);
		},
		async navigateToScanScreen(idParam) {
			await this.$router.push({ name: 'receiptfromproductionscan', params: { id: idParam } });
			// Emit the custom event to notify the child component
			this.$root.$emit('navigateToScanScreen');
		},
		getRectangleClass(documentStatus) {
			let cls = "rectangle";
			if(documentStatus == "CLOSED") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}
			return cls;
		},
		getReceiptFromProductions : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			if(!this.filter.documentStatusId) {
				this.filter.documentStatusId = "IN_PROGRESS,CLOSED";
			}

			this.filter["isDataFromLast7Days"] = false;

			if (!this.filter.workOrderProcessDetailId && !this.filter.documentStatusId ) {
				this.filter["isDataFromLast7Days"] = true;
			}

			let filterStatusArr = this.filter.documentStatusId.split(",");
			
			await ReceiptFromProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					if(filterStatusArr.length > 1) {
						this.filter.documentStatusId = null;
					}
					this.receiptFromProductions = result.data
					this.receiptFromProductionsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReceiptFromProductionsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			if(!this.filter.documentStatusId) {
				this.filter.documentStatusId = "IN_PROGRESS,CLOSED";
			}

			this.filter["isDataFromLast7Days"] = false;

			if (!this.filter.workOrderProcessDetailId && !this.filter.documentStatusId ) {
				this.filter["isDataFromLast7Days"] = true;
			}

			let filterStatusArr = this.filter.documentStatusId.split(",");

			await ReceiptFromProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.receiptFromProductions = result.data
					this.receiptFromProductionsPaging = result
					if(filterStatusArr.length > 1) {
						this.filter.documentStatusId = null;
					}
				}
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.lotNo = input;
			}
			await WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			// if (input != undefined) {
			// 	filter.name = input;
			// }

			filter.name = "IN PROGRESS,CLOSED";
			filter.exactType.name = 1;

			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReceiptFromProductionFilter();
			this.getReceiptFromProductions();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReceiptFromProductions();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReceiptFromProduction.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReceiptFromProduction.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReceiptFromProduction.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			ReceiptFromProduction.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'receiptfromproductionedit';
						if(this.isScannerMode) {
							createRoute = 'receiptfromproductionscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			ReceiptFromProduction.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'receiptfromproductionedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			ReceiptFromProduction.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReceiptFromProductions();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReceiptFromProduction.deleteMultipleData(this).then(result => {
					this.getReceiptFromProductions();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
				this.isMobileDevice = true;
			} else {
				this.isStacked = false;
				this.isMobileDevice = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReceiptFromProductionParent = document.getElementById('table-list-receiptfromproduction').parentNode;
			tableReceiptFromProductionParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReceiptFromProductionParent.scrollWidth - tableReceiptFromProductionParent.offsetWidth) == Math.ceil(tableReceiptFromProductionParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReceiptFromProductionParent = document.getElementById('table-list-receiptfromproduction').parentNode;
			tableReceiptFromProductionParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReceiptFromProductionParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReceiptFromProductionFilter();
		// this.getWorkOrderProcessDetails()
		// this.getDocumentStatuss()
	},
	mounted(){
		this.testGrouping();
		let breadcrumb =[
			"Master Data", 
			"Receipt From Production"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReceiptFromProductions();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReceiptFromProductions();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReceiptFromProductions();
			}
		},
		currentPage: {
			handler: function() {
				this.getReceiptFromProductions();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReceiptFromProductions();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReceiptFromProduction.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "receiptfromproductionindex") {
					this.getReceiptFromProductionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "receipt_from_production").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
